import React from 'react';
import Team from './Team';
import Hero from './Hero';
//import Navbar from '../Navbar';
//import Footer from '../Footer';

function About() {
  return (
    <>
     

      <Hero/>
      <Team/>

      
    </>
  );
}

export default About;